import { render, staticRenderFns } from "./molecule.patternMaker.mainView.patternMaker.vue?vue&type=template&id=ddbc804c"
import script from "./molecule.patternMaker.mainView.patternMaker.vue?vue&type=script&lang=ts"
export * from "./molecule.patternMaker.mainView.patternMaker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports